function updateCroFeatureSuffix(suffix, containerSelector) {
  // Get all containers
  const containers = 
    typeof containerSelector === "string" 
      ? document.querySelectorAll(containerSelector) 
      : (containerSelector instanceof NodeList ? containerSelector : [containerSelector]);

  containers.forEach(container => {
    // Find all elements inside container that have any of the data-cro-feature-* attributes
    const elements = container.querySelectorAll(
      "[data-cro-feature-clicked], [data-cro-feature-loaded], [data-cro-feature-viewed]"
    );

    elements.forEach(el => {
      ["clicked", "loaded", "viewed"].forEach(action => {
        const attr = `data-cro-feature-${action}`;
        const current = el.getAttribute(attr);
        if (current) {
          const base = current.slice(0, -1); // remove last character
          el.setAttribute(attr, base + suffix); // append new suffix
        }
      });
    });
  });
}



// Show one element by ID and hide another by ID
function showAndHideById(showId, hideId) {
    const showEl = document.getElementById(showId);
    const hideEl = document.getElementById(hideId);

    console.log("show:", showEl, "hide:", hideEl);

    if (hideEl) hideEl.classList.add("hidden");
    if (showEl) showEl.classList.remove("hidden");
}

function showHideByClass(showClass, hideClasses = []) {
  // Show all elements with showClass
  const showElements = document.querySelectorAll(`.${showClass}`);
  showElements.forEach(el => el.classList.remove("hidden"));

  // Hide all elements in hideClasses
  hideClasses.forEach(className => {
    const hideElements = document.querySelectorAll(`.${className}`);
    hideElements.forEach(el => el.classList.add("hidden"));
  });
}

function collectionFilterTestB() {
        console.log("RUNNING TEST: A");

        showAndHideById("hide-b", "placeholder-filter-nav");
        updateCroFeatureSuffix("b", ".collection-stacked-slider")
        updateCroFeatureSuffix("b", ".collection-filter-slider")

        const style = document.createElement('style');
        style.innerHTML = `
          .collection-stacked-slider .image-container,
          .collection-filter-slider .image-container{
            display:none;
          }

          [id^="collection-filter-slider-"] a,
          [id^="collection-filter-stacked-"] a{
            border: 1px solid black;
            border-radius: 9999px;
            text-align: center;
          }

          [id^="collection-filter-slider-"] a:hover,
          [id^="collection-filter-stacked-"] a:hover {
            color: #fff !important;
            background: #f00f83 !important;
            border: 1px solid #f00f83;
          }

          [id^="collection-filter-slider-"] a:hover p,
          [id^="collection-filter-stacked-"] a:hover p {
            color: #fff !important;
          }
        `;
        document.head.appendChild(style);

    }

    function collectionFilterTestA() {
        // console.log("RUNNING TEST: B");
        showAndHideById("hide-b", "placeholder-filter-nav");
        updateCroFeatureSuffix("a", ".collection-stacked-slider");
        updateCroFeatureSuffix("a", ".collection-filter-slider");
    }



document.addEventListener("DOMContentLoaded", function () {

    let themeTest = 'a';

    console.log("testing on theme", themeTest);


    if (themeTest === "a") {
        collectionFilterTestA();
    } else if (themeTest === "b") {
        collectionFilterTestB();

    } else {
        console.log("No matching test for theme:", themeTest);
        collectionFilterTestA();
    }

});
